// Hotels.tsx
"use client";

import MediaCardSkeleton from "@/components/skeletons/card/MediaCardSkeleton";
import HotelCard from "@/components/card/HotelCard";
import HomeCarouselSection from "@/components/home/HomeCarouselSection";
import { useHotelsCarousel } from "@/hooks/hotel/useHotel";
import { HotelCarouselItem } from "@/types/api";
import { useMediaQuery } from "@/hooks/useMediaQuery";

interface HotelCarouselProps {
  title: string;
  icon?: string;
  href?: string;
}

const HotelCarousel = ({ title, icon, href }: HotelCarouselProps) => {
  const isMdUp = useMediaQuery("(min-width: 768px)");
  const { data: hotels, isFetching, isError } = useHotelsCarousel();

  if (!isFetching && hotels?.length === 0) return null;

  return (
    <HomeCarouselSection<HotelCarouselItem>
      title={title}
      icon={icon}
      href={href}
      items={hotels}
      isFetching={isFetching}
      isError={isError}
      itemsPerCol={isMdUp ? 4 : 3}
      getKey={(hotel) => hotel.id}
      renderItem={(hotel) => <HotelCard hotel={hotel} />}
      renderSkeleton={() => <MediaCardSkeleton />}
    />
  );
};

export default HotelCarousel;
